import { FormControl, FormControlLabel, FormHelperText, Switch } from '@material-ui/core'
import { useField } from 'formik'
import React from 'react'
import { FIELD_MODE } from '~/common/constants'
import { useFieldError } from '~/common/hooks'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'
import { authStore } from '~/stores'

const WrapperSwitch = styled.div`
	.MuiFormControlLabel-root {
		padding: 0 !important;
		margin: 0 !important;
	}
`

const useStyles = makeStyles((theme) => ({
	root: {
		padding: 0,
		margin: theme.spacing(1),
		marginLeft: 0,
	},
	switchBase: {
		padding: 1,
		'&$checked': {
			transform: 'translateX(16px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: theme.palette.primary.main,
				opacity: 1,
				border: 'none',
			},
		},
		'&$focusVisible $thumb': {
			color: theme.palette.primary.main,
			border: '6px solid #fff',
		},
	},
	track: {
		borderRadius: 26 / 2,
		border: `1px solid ${theme.palette.grey[400]}`,
		backgroundColor: theme.palette.grey[200],
		opacity: 1,
		transition: theme.transitions.create(['background-color', 'border']),
	},
	checked: {},
	focusVisible: {},
}))

export const SwitchField = ({ name, validate, label, mode, defaultChecked = false, callBackFunction, isDrawer = false, ...props }) => {
	const { disabled, id, callBackHandler, nameAttribute, callBackSwitchFieldCheck } = props

	const { t } = useTranslation()
	const classes = useStyles()

	const [field, meta] = useField({
		name,
		validate: mode === FIELD_MODE.edit && validate,
	})
	const error = useFieldError(meta)
	const handleChange = (event, checked) => {
		event.target.value = checked
		if (callBackHandler) {
			callBackHandler(event.target.id, nameAttribute)
		}
		if (mode === FIELD_MODE.edit) {
			field.onChange(event)
		}
		if (checked && isDrawer && authStore.isAnonymous) {
			callBackFunction()
		}
		if (callBackSwitchFieldCheck) {
			callBackSwitchFieldCheck(checked, event.target.name, event.target.id)
		}
	}
	return (
		<WrapperSwitch>
			<FormControl error={!!error}>
				<FormControlLabel
					control={
						<Switch
							id={id}
							disabled={disabled}
							onChange={handleChange}
							checked={field.value || false}
							name={name}
							focusVisibleClassName={classes.focusVisible}
							disableRipple
							classes={{
								root: classes.root,
								switchBase: classes.switchBase,
								thumb: classes.thumb,
								track: classes.track,
								checked: classes.checked,
							}}
						/>
					}
					label={t(label)}
				/>
				{error && <FormHelperText>{error}</FormHelperText>}
			</FormControl>
		</WrapperSwitch>
	)
}

SwitchField.defaultProps = {
	mode: FIELD_MODE.edit,
}
